<template>
  <div class="app-wave">
    <div
      class="app-wave__background"
      :class="{
        'app-wave__background--primary': primaryColor,
        'app-wave__background--secondary': secondaryColor,
        'app-wave__background--light-grey': contrastColor,
        'app-wave__background--white': whiteColor,
      }"
    >
      <div
        v-if="showTop"
        class="app-wave__background-top"
      />
      <div class="app-wave__background-center" />
      <div
        v-if="showBottom"
        class="app-wave__background-bottom"
      />
    </div>
    <div class="app-wave__content">
      <slot />
    </div>
  </div>
</template>

<script setup>
  defineProps({
    showTop: {
      type: Boolean,
      default: true,
    },
    showBottom: {
      type: Boolean,
      default: true,
    },
    primaryColor: {
      type: Boolean,
      default: false,
    },
    secondaryColor: {
      type: Boolean,
      default: false,
    },
    contrastColor: {
      type: Boolean,
      default: false,
    },
    whiteColor: {
      type: Boolean,
      default: false,
    },
  })
</script>

<style lang="scss">
  .app-wave {
    padding: 20px 0 0;
    position: relative;
  }

  .app-wave__background {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    z-index: -1;
    display: flex;
    flex-direction: column;
  }

  .app-wave__background--secondary .app-wave__background-bottom,
  .app-wave__background--secondary .app-wave__background-top,
  .app-wave__background--secondary .app-wave__background-center {
    background: var(--color-secondary);
  }

  .app-wave__background--primary .app-wave__background-bottom,
  .app-wave__background--primary .app-wave__background-top,
  .app-wave__background--primary .app-wave__background-center {
    background: var(--color-primary);
  }

  .app-wave__background--light-grey .app-wave__background-bottom,
  .app-wave__background--light-grey .app-wave__background-top,
  .app-wave__background--light-grey .app-wave__background-center {
    background: #e9e9ef;
  }

  .app-wave__background--white .app-wave__background-bottom,
  .app-wave__background--white .app-wave__background-top,
  .app-wave__background--white .app-wave__background-center {
    background: white;
  }

  //https://www.wavegenerator.app/
  .app-wave__background-top {
    height: 30px;
    transform: translateY(1px);
    background: white;
    clip-path: polygon(
      100% 100%,
      0% 100%,
      0% 10.35%,
      1% 10.22%,
      2% 10.11%,
      3% 10.04%,
      4% 10.01%,
      5% 10%,
      6% 10.03%,
      7% 10.09%,
      8% 10.19%,
      9% 10.32%,
      10% 10.48%,
      11% 10.67%,
      12% 10.89%,
      13% 11.15%,
      14% 11.44%,
      15% 11.76%,
      16% 12.11%,
      17% 12.49%,
      18% 12.9%,
      19% 13.34%,
      20% 13.81%,
      21% 14.3%,
      22% 14.83%,
      23% 15.38%,
      24% 15.95%,
      25% 16.55%,
      26% 17.17%,
      27% 17.82%,
      28% 18.49%,
      29% 19.17%,
      30% 19.88%,
      31% 20.61%,
      32% 21.36%,
      33% 22.12%,
      34% 22.9%,
      35% 23.69%,
      36% 24.5%,
      37% 25.32%,
      38% 26.15%,
      39% 27%,
      40% 27.85%,
      41% 28.71%,
      42% 29.57%,
      43% 30.44%,
      44% 31.32%,
      45% 32.19%,
      46% 33.07%,
      47% 33.95%,
      48% 34.83%,
      49% 35.71%,
      50% 36.58%,
      51% 37.45%,
      52% 38.31%,
      53% 39.17%,
      54% 40.02%,
      55% 40.85%,
      56% 41.68%,
      57% 42.5%,
      58% 43.3%,
      59% 44.09%,
      60% 44.86%,
      61% 45.62%,
      62% 46.35%,
      63% 47.07%,
      64% 47.78%,
      65% 48.46%,
      66% 49.12%,
      67% 49.75%,
      68% 50.36%,
      69% 50.95%,
      70% 51.52%,
      71% 52.06%,
      72% 52.57%,
      73% 53.05%,
      74% 53.51%,
      75% 53.94%,
      76% 54.33%,
      77% 54.7%,
      78% 55.04%,
      79% 55.35%,
      80% 55.62%,
      81% 55.87%,
      82% 56.08%,
      83% 56.26%,
      84% 56.41%,
      85% 56.52%,
      86% 56.6%,
      87% 56.65%,
      88% 56.67%,
      89% 56.65%,
      90% 56.6%,
      91% 56.51%,
      92% 56.4%,
      93% 56.25%,
      94% 56.06%,
      95% 55.85%,
      96% 55.6%,
      97% 55.33%,
      98% 55.02%,
      99% 54.68%,
      100% 54.31%
    );

    @include breakpoint(desktop) {
      clip-path: polygon(
        100% 100%,
        0% 100%,
        0% 31.16%,
        1% 29.99%,
        2% 28.82%,
        3% 27.66%,
        4% 26.51%,
        5% 25.4%,
        6% 24.31%,
        7% 23.28%,
        8% 22.29%,
        9% 21.37%,
        10% 20.51%,
        11% 19.72%,
        12% 19.01%,
        13% 18.39%,
        14% 17.86%,
        15% 17.42%,
        16% 17.08%,
        17% 16.84%,
        18% 16.7%,
        19% 16.67%,
        20% 16.73%,
        21% 16.9%,
        22% 17.18%,
        23% 17.55%,
        24% 18.01%,
        25% 18.57%,
        26% 19.22%,
        27% 19.95%,
        28% 20.76%,
        29% 21.64%,
        30% 22.58%,
        31% 23.58%,
        32% 24.64%,
        33% 25.73%,
        34% 26.86%,
        35% 28.01%,
        36% 29.17%,
        37% 30.34%,
        38% 31.51%,
        39% 32.67%,
        40% 33.81%,
        41% 34.92%,
        42% 35.99%,
        43% 37.01%,
        44% 37.98%,
        45% 38.89%,
        46% 39.73%,
        47% 40.49%,
        48% 41.17%,
        49% 41.77%,
        50% 42.27%,
        51% 42.68%,
        52% 43%,
        53% 43.21%,
        54% 43.32%,
        55% 43.32%,
        56% 43.23%,
        57% 43.03%,
        58% 42.73%,
        59% 42.33%,
        60% 41.84%,
        61% 41.25%,
        62% 40.58%,
        63% 39.83%,
        64% 39%,
        65% 38.1%,
        66% 37.14%,
        67% 36.12%,
        68% 35.06%,
        69% 33.95%,
        70% 32.82%,
        71% 31.66%,
        72% 30.49%,
        73% 29.32%,
        74% 28.15%,
        75% 27%,
        76% 25.87%,
        77% 24.77%,
        78% 23.72%,
        79% 22.71%,
        80% 21.75%,
        81% 20.87%,
        82% 20.05%,
        83% 19.31%,
        84% 18.65%,
        85% 18.08%,
        86% 17.6%,
        87% 17.22%,
        88% 16.93%,
        89% 16.75%,
        90% 16.67%,
        91% 16.69%,
        92% 16.82%,
        93% 17.05%,
        94% 17.38%,
        95% 17.8%,
        96% 18.32%,
        97% 18.93%,
        98% 19.63%,
        99% 20.4%,
        100% 21.25%
      );
    }
  }

  .app-wave__background-center {
    background: white;
    flex-grow: 1;
  }

  .app-wave__background-bottom {
    background: white;
    height: 50px;
    transform: translateY(-1px);
    clip-path: polygon(
      100% 0%,
      0% 0%,
      0% 60%,
      2% 59.77%,
      4% 59.1%,
      6% 57.99%,
      8% 56.47%,
      10% 54.58%,
      12% 52.36%,
      14% 49.85%,
      16% 47.13%,
      18% 44.24%,
      20% 41.26%,
      22% 38.24%,
      24% 35.27%,
      26% 32.4%,
      28% 29.71%,
      30% 27.25%,
      32% 25.08%,
      34% 23.25%,
      36% 21.8%,
      38% 20.76%,
      40% 20.16%,
      42% 20.01%,
      44% 20.31%,
      46% 21.06%,
      48% 22.24%,
      50% 23.82%,
      52% 25.77%,
      54% 28.04%,
      56% 30.59%,
      58% 33.34%,
      60% 36.25%,
      62% 39.25%,
      64% 42.26%,
      66% 45.22%,
      68% 48.06%,
      70% 50.72%,
      72% 53.13%,
      74% 55.25%,
      76% 57.02%,
      78% 58.4%,
      80% 59.37%,
      82% 59.9%,
      84% 59.97%,
      86% 59.6%,
      88% 58.77%,
      90% 57.53%,
      92% 55.88%,
      94% 53.87%,
      96% 51.55%,
      98% 48.97%,
      100% 46.18%
    );
  }

  .app-wave__content {
    padding: 24px 0;

    @include breakpoint(desktop) {
      padding: 48px 0;
    }
  }
</style>
